import { useState } from "react";
import { Reveal, PillButton } from "./ui";
import { postProductIdea } from "./api";

const categories = ["Color", "Material", "Print", "Bag Style", "Feature", "Bring Something Back", "Completely New Idea"];

export const ProductIdea = () => {
  const [first, setFirst] = useState("");
  const [email, setEmail] = useState("");
  const [idea, setIdea] = useState("");
  const [category, setCategory] = useState("");
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!idea.trim()) return;
    setSaving(true);
    try { await postProductIdea({ first_name: first, email: email || null, idea, category }); setDone(true); } catch {} finally { setSaving(false); }
  };

  return (
    <section id="product-idea" className="px-6 md:px-12 lg:px-16 py-16 md:py-24 border-t border-[var(--line)]" data-testid="product-idea-section">
      <div className="max-w-[760px] mx-auto">
        <Reveal>
          <div className="text-center">
            <span className="eyebrow">Community · Build What's Next</span>
            <h2 className="mt-4 text-[clamp(2rem,4.5vw,3.2rem)] leading-[1.03]">Help build <span className="italic" style={{ color: "var(--clay)" }}>what comes next.</span></h2>
            <p className="mt-4 text-[1.05rem] text-[var(--ink-soft)] max-w-[36rem] mx-auto">
              You've always been part of Sash. Some of the best things we've ever made started with someone saying, "You know what would be cool?" So tell us. A color, a print, a feature, a style to bring back, or something completely unhinged nobody's thought of yet.
            </p>
          </div>
        </Reveal>

        {done ? (
          <div className="result-card mt-10 text-center" data-testid="product-idea-done">
            <p className="sash-serif italic text-2xl text-[var(--tan-deep)]">Sent to Sash! 💌</p>
            <p className="mt-2 text-[var(--ink-soft)]">We read every single one. Thank you.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="result-card mt-10 space-y-4" data-testid="product-idea-form">
            <div className="flex flex-col sm:flex-row gap-3">
              <input className="sf-input sm:max-w-[170px]" placeholder="First name" value={first} onChange={(e) => setFirst(e.target.value)} data-testid="idea-firstname" />
              <input className="sf-input flex-1" type="email" placeholder="Email (optional)" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="idea-email" />
            </div>
            <div>
              <p className="text-sm font-bold mb-2">Category (optional)</p>
              <div className="flex flex-wrap gap-2">
                {categories.map((c) => (
                  <button type="button" key={c} className={`dl-chip ${category === c ? "sel" : ""}`} onClick={() => setCategory(category === c ? "" : c)} data-testid={`idea-cat-${c.replace(/\s+/g, "-")}`}>{c}</button>
                ))}
              </div>
            </div>
            <textarea className="sf-input" rows={4} placeholder="My idea…" value={idea} onChange={(e) => setIdea(e.target.value)} data-testid="idea-text" />
            <PillButton type="submit" testid="product-idea-submit">{saving ? "…" : "Send It To Sash"}</PillButton>
          </form>
        )}
      </div>
    </section>
  );
};
